// Optional free-text notes from the customer. Common reasons people fill
// this in:
//   - "Please use a navy thread for the outline instead of black"
//   - "This is for my dad's birthday on the 24th, any chance of express?"
//   - "The logo PNG has a transparent background; please centre it within
//      the area not the bounding box"
//
// Non-blocking: leaving it empty is fine. When filled, the text rides into
// the cart line as a visible "Customer notes" property (built in
// pricing.ts from this value).
//
// Wave 3: the accordion step wrapper was retired; the field now lives
// inside a COLLAPSED "Add a note (optional)" disclosure on the
// consolidated finish screen (sections/FinishSection.tsx).

const MAX_LEN = 500;

export function NotesField({
  value,
  onChange,
}: {
  value: string;
  onChange: (next: string) => void;
}) {
  const len = value.length;
  return (
    <>
      <label className="rk-pc-notes-label" htmlFor="rk-pc-notes-input">
        Notes for the embroidery team
      </label>
      <textarea
        id="rk-pc-notes-input"
        className="rk-pc-notes-input"
        placeholder="e.g. swap the outline thread to navy, or please centre the design within the visible artwork not the bounding box."
        value={value}
        maxLength={MAX_LEN}
        onChange={(e) => onChange(e.target.value)}
        rows={4}
      />
      <div className="rk-pc-notes-foot">
        <span className="rk-pc-notes-hint">
          Optional. Leave blank if there's nothing extra.
        </span>
        <span className={`rk-pc-notes-count${len >= MAX_LEN - 20 ? " is-warning" : ""}`}>
          {len}/{MAX_LEN}
        </span>
      </div>
    </>
  );
}
